import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandRelesys(props: IconProps) {
  return (
    <BaseIcon size={40} {...props}>
      <path
        d="m21.216 12.43-.007-.008a2.748 2.748 0 0 0-3.212-1.171c-.25.085-.475.221-.675.393l-.598.515-5.029 4.347c-.03.026-.063.05-.093.076a1.347 1.347 0 0 0-.328 1.75l.006.008a1.248 1.248 0 0 0 .2.254 1.372 1.372 0 0 0 1.515.29c.037-.016.074-.034.11-.047l6.233-2.364.74-.28c.245-.094.473-.229.666-.407a2.69 2.69 0 0 0 .472-3.355ZM11.271 13.517c.34-.506.296-1.1-.002-1.53a1.614 1.614 0 0 1-.068-.1L7.672 6.27s-.25-.398-.42-.665a2.016 2.016 0 0 0-.53-.572 2.753 2.753 0 0 0-3.41.18c-.001.003-.004.005-.008.007l-.009.007a2.709 2.709 0 0 0-.769 2.818c.059.187.137.365.233.528.13.226.31.422.517.583l.623.482 5.264 4.068c.033.024.063.05.093.077a1.374 1.374 0 0 0 1.796-.016.03.03 0 0 1 .008-.006l.009-.007c.072-.07.141-.147.202-.237ZM14.441 9.145a2.405 2.405 0 0 0 2.408-2.402 2.405 2.405 0 0 0-2.408-2.401 2.405 2.405 0 0 0-2.408 2.401 2.405 2.405 0 0 0 2.408 2.402Z"
        fill="#EA6F63"
      />
    </BaseIcon>
  );
}
